import { AxiosError } from 'axios';

/**
 * React Query retry policy. A "hard" HTTP error means the server actually
 * responded with a 4xx/5xx — retrying won't change the outcome (a 403/404/422/
 * 500 stays a 403/404/422/500), so we attempt once and surface it immediately.
 * Only genuinely transient failures (no response: network drop, timeout) keep a
 * retry budget.
 */
export function retryUnlessHardHttp(failureCount: number, error: unknown): boolean {
  const status =
    (error instanceof AxiosError ? error.response?.status : undefined) ??
    (error as { statusCode?: number })?.statusCode ??
    (error as { status?: number })?.status;
  if (typeof status === 'number' && status >= 400 && status < 600) return false;
  // Transient/network error (no HTTP response) — keep React Query's default budget.
  return failureCount < 3;
}
